import UcInvoicePayments from './UcInvoicePayments.yaml?component';

export { UcInvoicePayments };
